/**
 * @desc generateSkuQuote
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/skuQuote/generateSkuQuote`, {
      method: "POST",

      ...options,
    }),
  );
}
